import(/* webpackMode: "eager" */ "/app/src/app/tools/correlation-calculator/page.tsx");
